exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newsletter-action__content__interaction__scroll-container[data-v-2235cbbc]{margin-top:0}.newsletter-action__content__header-buttons .menu--cross[data-v-2235cbbc]{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2235cbbc","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/site/components/newsletter-widget/thanks-for-subscribing-slide.vue
// module id = rXMf
// module chunks = 0